import React from 'react';
import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
const DEFAULT_HEIGHT = 'h-72';
export function ChartCard(props) {
    const { title, description, value, delta, action, footer, empty, isEmpty = false, isLoading = false, className, headerClassName, contentClassName, contentHeightClassName = DEFAULT_HEIGHT, children, } = props;
    const trend = delta ? formatTrend(delta.value) : null;
    return (<Card className={cn('border-border/60 overflow-hidden', className)}>
            <CardHeader className={cn('gap-1 pb-2', headerClassName)}>
                <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0 space-y-1">
                        <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
                        {description ? <CardDescription className="text-xs">{description}</CardDescription> : null}
                    </div>
                    {action ? <div className="shrink-0">{action}</div> : null}
                </div>
                {(value !== undefined && value !== null) || trend ? (<div className="mt-1 flex items-baseline gap-2">
                        {value !== undefined && value !== null ? (<span className="text-2xl font-semibold tracking-tight tabular-nums text-foreground">
                                {value}
                            </span>) : null}
                        {trend ? (<span className={cn('inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-xs font-medium', trend.tone === 'up' && 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400', trend.tone === 'down' && 'bg-rose-500/10 text-rose-600 dark:text-rose-400', trend.tone === 'flat' && 'bg-muted text-muted-foreground')} aria-label={`${trend.text}${delta?.label ? ` ${asLabelString(delta.label)}` : ''}`}>
                                {trend.tone === 'up' ? (<ArrowUpRight className="h-3 w-3" aria-hidden/>) : trend.tone === 'down' ? (<ArrowDownRight className="h-3 w-3" aria-hidden/>) : null}
                                {trend.text}
                            </span>) : null}
                        {delta?.label ? <span className="text-xs text-muted-foreground">{delta.label}</span> : null}
                    </div>) : null}
            </CardHeader>
            <CardContent className={cn('pt-2', contentClassName)}>
                <div className={cn('relative w-full', contentHeightClassName)}>
                    {isLoading ? (<Skeleton className="absolute inset-0 rounded-md"/>) : isEmpty ? (<div className="absolute inset-0 flex items-center justify-center rounded-md bg-muted/20 text-sm text-muted-foreground">
                            {empty ?? 'No data yet'}
                        </div>) : (children)}
                </div>
            </CardContent>
            {footer ? (<CardFooter className="border-border/40 border-t pt-3 text-xs text-muted-foreground">
                    {footer}
                </CardFooter>) : null}
        </Card>);
}
function formatTrend(value) {
    if (!Number.isFinite(value) || Math.abs(value) < 0.05) {
        return { tone: 'flat', text: '0%' };
    }
    const tone = value > 0 ? 'up' : 'down';
    const sign = value > 0 ? '+' : '';
    return { tone, text: `${sign}${value.toFixed(value % 1 === 0 ? 0 : 1)}%` };
}
function asLabelString(node) {
    if (typeof node === 'string' || typeof node === 'number') {
        return String(node);
    }
    return '';
}
